import * as React from 'react'
import styled from 'styled-components'
import { BodyText } from '../../../../common/src/components/core'
import { Colors } from '../../../../common/src/constants'
import { dateFmt, timeTzFmt } from '../../../../common/src/date'

/**
 * this component goes between messages in a scrollable chat history to indicate the passage of time
 * between messages, similarly to how it works in something like FB messenger
 */
export const MessageSeparator = ({
  dateString,
  showTime,
  showDate,
}: {
  dateString: string
  showTime: boolean
  showDate: boolean
}) => (
  <MessageSeparatorContainer>
    {showDate ? dateFmt(dateString) : null} {showTime ? timeTzFmt(dateString) : null}
    {!showDate && !showTime ? <SolidHorizontalSeparator /> : null}
  </MessageSeparatorContainer>
)

const SolidHorizontalSeparator = styled.div`
  width: 100px;
  background-color: ${Colors.midway};
  height: 1px;
`

const MessageSeparatorContainer = styled(BodyText)`
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px;
`
